import { useCallback } from "react";

import { onboardingAgentTrackingService } from "../../onboardingAgentTrackingService";

type UseOnboardingAgentThumbsUpFeedbackParams = {
    readonly messageIndex: number;
    readonly isActive: boolean;
    readonly threadId?: string;
    readonly onActiveChange: (active: boolean) => void;
    readonly onClearDislike: () => void;
};

export const useOnboardingAgentThumbsUpFeedback = ({
    messageIndex,
    isActive,
    threadId,
    onActiveChange,
    onClearDislike,
}: UseOnboardingAgentThumbsUpFeedbackParams) => {
    const handleClick = useCallback((): void => {
        const nextLiked = !isActive;

        onActiveChange(nextLiked);

        if (nextLiked) {
            onboardingAgentTrackingService.trackFeedback({ type: "like", messageIndex, threadId });
            onClearDislike();
        }
    }, [isActive, messageIndex, onActiveChange, onClearDislike, threadId]);

    return {
        handleClick,
    };
};
